import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
/* All four families are declared up front; the browser only downloads the faces the chosen
   family actually renders with, so the unselected ones cost nothing at runtime. Fira Sans has
   no variable build, hence the two explicit weights. */
import "@fontsource-variable/noto-sans/wght.css";
import "@fontsource-variable/roboto/wght.css";
import "@fontsource-variable/open-sans/wght.css";
import "@fontsource/fira-sans/400.css";
import "@fontsource/fira-sans/700.css";
import App from "./App";
import { installBackNavigation } from "./backNavigation";
import { DiagnosticsErrorBoundary } from "./components/DiagnosticsErrorBoundary";
import { diagnostics } from "./diagnostics";
import { preferPrimaryOrigin } from "./primaryOrigin";
import "./styles.css";

diagnostics.start();

// Only the primary can reach the printers, so send the app there whenever it is up. Rendering
// continues meanwhile; if the check decides to move, this page is replaced a moment later.
// The device Back button is taken over only once the app knows it is staying on this origin;
// a guard entry pushed just before the move would leave the old origin one Back press away.
void preferPrimaryOrigin().then((moving) => {
  if (!moving) {
    installBackNavigation();
  }
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <DiagnosticsErrorBoundary>
      <App />
    </DiagnosticsErrorBoundary>
  </StrictMode>
);
